import { SET_BROWSER_NOTIFICATION_PERMISSION_STATUS } from '../actions/types';

const defaultState = {
	// "default" until setup runs, then one of:
	// "granted" (on), "disabled" (off), "denied" (blocked in the browser),
	// "unsupported" (the browser can't receive push)
	permissionStatus: 'default',
};

export default function browserNotificationsReducer(
	state = defaultState,
	action
) {
	switch (action.type) {
		case SET_BROWSER_NOTIFICATION_PERMISSION_STATUS:
			return { permissionStatus: action.payload };
		default:
			return state;
	}
}
